import React from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import DataConnector from 'connect/DataConnector';
import {GRID_SCHEMA_CLASS_TO_TYPE_TEXT, GridSchemaClass} from 'constants/SampleConstants';
import * as RegistryUtil from 'registry/RegistryUtil';
import * as SampleSchemaActions from 'samples/SampleSchemaActions';
import SampleSchemaStore from 'samples/SampleSchemaStore';
import {BoxSchema, PlateSchema} from 'samples/storables/StorableSchemaConstants';
import GridSchemasListing from 'settings/samples/GridSchemasListing';

interface GridSchemasPageProps {
  registryId: string;
  ownerUrlId: string;
  gridSchemaClass: GridSchemaClass;
}

interface ConnectedProps {
  gridSchemas: Array<BoxSchema | PlateSchema> | null;
}

class GridSchemasPageConnector extends DataConnector<GridSchemasPageProps, ConnectedProps> {
  override shouldSubscribeToRedux = false;
  override stores = [SampleSchemaStore];

  enhanceProps(): ConnectedProps {
    return {
      gridSchemas: this.sampleSchemaStore().getGridSchemas(
        this.props.registryId,
        this.props.gridSchemaClass,
        {
          includeArchived: true,
        }
      ),
    };
  }
}

export class GridSchemasPage extends React.Component<
  GridSchemasPageProps &
    ConnectedProps & {
      isWritable: boolean;
    }
> {
  override componentDidMount(): void {
    SampleSchemaActions.fetchAllGridSchemas(this.props.gridSchemaClass);
  }

  override render(): JSX.Element {
    setWindowTitle(
      `${GRID_SCHEMA_CLASS_TO_TYPE_TEXT[this.props.gridSchemaClass]} Schemas - Registry Settings`
    );

    return (
      <GridSchemasListing
        gridSchemaClass={this.props.gridSchemaClass}
        gridSchemas={this.props.gridSchemas}
        isWritable={this.props.isWritable}
        ownerUrlId={this.props.ownerUrlId}
        registryId={this.props.registryId}
      />
    );
  }
}

function QueryingGridSchemasPage(props: GridSchemasPageProps & ConnectedProps): JSX.Element {
  const isWritable = RegistryUtil.useIsRegistryWritableQuery(props.registryId);
  return <GridSchemasPage {...props} isWritable={isWritable} />;
}

export default GridSchemasPageConnector.connect(QueryingGridSchemasPage);
